import React from 'react';
import { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router-dom';


const EventIDPage = () => {
  
  const location = useLocation();
  const URL = window.location.href;
  const urlEventId = URL.split("/").slice(-1)[0]; // Consistent use of URL
 
  const history = useHistory();

  useEffect(() => {
    localStorage.setItem('eventid', urlEventId);
  }, [urlEventId]);

  useEffect(() => {
    // Redirect based on URL
    if (URL !== "") {
      history.push('/author/login');
    }
  }, [URL, history]);

  return null; 



}

export default EventIDPage





